import { InitialCausalityFilter } from '../../../../../shared/types/typifications/initialCausality';

export const initialValues: InitialCausalityFilter = {
    product: [],
    motive: [],
    submotive1: '',
    submotive2: '',
    submotive3: '',
    submotive4: '',
    active: true,
    motiveName: '',
    sfcMotiveIdComplaint: '',
    typeComplaint: '',
    typePqr: [],
    technicalBranch: '',
    unifiedProduct: '',
    typeMotive: '',
};
